import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import * as FwDatas from "../FwDatas.ts";
import ApiServer from "../ApiServer.js";
import TPL from "../mealplanner/recipePreview.mustache";

var theNode;

Html.register({
  "mppreviewclose":function(){
    theNode.removeClass('open')  
  },
  
})

function show(id){
  var 
    item = FwDatas.get(id);
  if(item instanceof ApiServer.types.DishBean){
    item = FwDatas.get(item.recipeId) || item;
  }
  if(theNode){
    theNode.addClass('open')
    Html.setHtml(theNode,TPL,item)
  }
}
function init(node){
  theNode = node;
  amplify.subscribe("mpclick",show);
}
function destroy(node){
  theNode = undefined;
  amplify.unsubscribe("mpclick",show);
}
Html.registerWidget('widget/recipePreview',{init:init,destroy:destroy})

export{init,destroy}
